<template>
  <center>
    <div class="card card-body agatrs-card-style">
      <div class="col-md-12">
        <Header pageTitle="Edit Profile " class="card-container"></Header>
 <div class="d-flex justify-content-end ">
          <base-button type="link" @click="$router.push(`/admin/audit-logs/${$route.params.id}`)">
            <i style="font-size: 24px;" class="tim-icons icon-paper"></i>
          </base-button>
        </div>
        <form @submit.prevent="updateProfile">
          <div class="row">
            <div class="col-md-6">
              <legend>Edit Information</legend>

              <hr />
              <fieldset>
                <div class="edit_information_grid">
                  <div>
                    <base-input type="text" label="First Name" :disabled="isAllowEdit" placeholder="First Name"
                      v-model="user.firstName">
                    </base-input>
                  </div>
                  <div>
                    <base-input label="Middle Name" :disabled="isAllowEdit" v-model="user.middleName"
                      placeholder="Middle Name" addon-left-icon="tim-icons icon-single-02"></base-input>
                  </div>
                  <div>
                    <base-input type="text" label="Last Name" placeholder="Last Name" :disabled="isAllowEdit"
                      v-model="user.lastName" addon-left-icon="tim-icons icon-single-02">
                    </base-input>
                  </div>
                  <div>
                    <base-input label="Title" :error="getError('title')" :disabled="isAllowEdit" v-model="user.title"
                      name="title" type="text" placeholder="Title" addon-left-icon="tim-icons icon-badge"></base-input>
                  </div>
                  <div>
                    <base-input label="Phone Number" :error="getError('phoneNumber')" :disabled="isAllowEdit"
                      v-model="user.phoneNumber" name="phonenumber" type="text" placeholder="Phone number"
                      addon-left-icon="tim-icons icon-mobile"></base-input>
                  </div>
                  <div>
                    <base-input label="Email" v-model="user.email" name="email" placeholder="Email"
                      addon-left-icon="tim-icons icon-email-85"></base-input>
                  </div>

                  <div>
                    <base-input :disabled="true" v-model="user.approvalStatusName" label="Status">
                    </base-input>
                  </div>
                  <div>
                    <base-input :disabled="true" v-model="this.user.approverNameLabel" label="Approver">
                    </base-input>

                  </div>
                </div>
              </fieldset>

              <fieldset>
                <div class="row">
                  <div class="col-md-12">
                    <base-input :label="isPartner ? 'Partner Nation Manager' : 'Sponsor'" :error="getError('sponsor')">
                      <v-select class="style-chooser" v-model="user.sponsorId"
                        :aria-label="`${selectedSponserUserLabel}`" name="sponsor" :reduce="(user) => user.id"
                        label="nameLabel" :options="sponsorUsers" placeholder="Select one">
                        <template v-slot:option="option">
                          {{ option.nameLabel }}
                        </template>
                      </v-select>
                    </base-input>
                  </div>
                </div>
              </fieldset>

              <fieldset>
                <div class="row">
                  <div class="col-md-6">
                    <base-input v-if="!isPartner" :disabled="isOUSD" label="Organization"
                      :error="getError('organization')">
                      <treeselect :disabled="isOUSD" aria-label="Select organization from the dropdown list"
                        v-model="user.organizationId" class="select-primary" name="organization"
                        :options="jointStaffOrganizations" />
                    </base-input>

                    <base-input v-if="isPartner" label="Country" disabled="true" v-model="userCountries">
                    </base-input>
                  </div>
                  <div v-if="!isPartner" class="col-md-6">
                    <base-input label="CAC SubjectName" v-model="user.subjectName">
                    </base-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <base-input label="Role(s)" :error="getError('roles')">
                      <v-select :disabled="(isPartner && isPartnerRoleAssigned) || isOUSD
                        " v-model="user.roles" name="roles" multiple :reduce="(role) => role.name" label="name"
                        :options="roles" placeholder="Select one">
                        <template #option="option">
                          <div :class="{ 'isNotApproved': !option.isActive }">
                            {{ option.name }}
                          </div>
                        </template>
                      </v-select>
                    </base-input>
                  </div>
                </div>

                <div v-if="!isOUSD" class="row">


                </div>
              </fieldset>

              <base-button v-if="!isOUSD" native-type="submit" size="md" :class="'btn_extra_small btn-primary'">
                Update Information
              </base-button>
              <router-link :to="'/admin/user-modifications'" class="btn btn-secondary"><span> Back </span></router-link>

              <div class="row">
                <div class="col-md-12 italics">
                  <label for="LastLoginDate">{{ lastLoggedInInfo }} </label>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 italics">
                  <label for="CreateDate">{{ createdDate }} </label>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 italics">
                  <label for="EmailConfirmation">{{ confirmedEmailInfo }}
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 italics">
                  <label for="LastUpdatedBy">{{ lastUpdatedByInfo ? lastUpdatedByInfo : '' }}
                  </label>
                </div>
              </div>
            </div>


            <div class="col-md-6">

              <fieldset>

                <legend>Documentation</legend>
                <user-upload v-if="!isOUSD" :email="user.email" :type="'team'"></user-upload>
              </fieldset>
              <hr />
              <fieldset>
                <legend v-if="!isOUSD">Other Settings</legend>
                <base-button v-if="!isOUSD" type="dark" class="btn-fill" @click="resendEmailConfirmation()"
                  :disabled="buttonDisabled">
                  Resend Email Confirmation Link
                </base-button>

                <el-tooltip v-if="user.isCacRegistered" :visible="visible" class="display-inline" effect="light"
                  placement="top" content="CAC registered">
                  <!-- <div  onmouseover="visible= true" class="ml-2">
                        </div> -->
                  <base-button class="btn btn-default btn-md  btn-secondary" :disabled="user.isCacRegistered"><span><i
                        class="tim-icons icon-badge"></i> CAC Registered</span></base-button>
                </el-tooltip>

              </fieldset>
              <hr />
              <fieldset>
                <div style="width: 300px;" class="content_padding_top_small date">
                  <label for="signatureDate">Account Expiration</label>
                  <el-date-picker id="signatureDate" type="date" v-model="user.expirationDate" format="dd-MMMM-yyyy"
                    data-vv-as="Account Expiration" name="dateSigned" :editable="false"
                    :picker-options="endDatePickerOptions" :clearable="false">
                  </el-date-picker>
                </div>
                <span>Please select date in range of 1 year</span>

              </fieldset>

              <fieldset v-if="isVisible">
                <legend>Partner Nations Managed</legend>

                <el-card class="box-card" shadow="always">
                  <div style="text-align: left;" v-for="i in allCountries" :key="i.id" class="text item"><el-checkbox
                      v-model="countrySelected" :value="i" :label="i.name" /></div>
                </el-card>
              </fieldset>
            </div>
          </div>
        </form>
      </div>
    </div>
  </center>
</template>

<script>
import UserUpload from "@/components/App/account/documents/UserDocuments";
import LockButton from "@/components/App/account/LockButton";
import ApprovalModal from "@/components/App/account/Approval";
import { mapGetters, mapActions } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import Header from "@/components/App/Header.vue";
import swal from "sweetalert2";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Util from "@/util/util";
import axios from "@/axios";
import moment from "moment";
import {
  Table,
  TableColumn,
  Upload,
  Button,
  Tag,
  Select,
  Option,
  Alert,
  Form,
  FormItem,
  CheckboxGroup,
  Checkbox,
  Divider,
  Tooltip,
  Card,
} from "element-ui";
export default {
  name: "AdminUserProfile",
  components: {
    ApprovalModal,
    LockButton,
    UserUpload,
    [Card.name]: Card,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Upload.name]: Upload,
    [Button.name]: Button,
    [Alert.name]: Alert,
    [Tag.name]: Tag,
    [Form.name]: Form,
    [Tooltip.name]: Tooltip,
    [FormItem.name]: FormItem,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Divider.name]: Divider,
    [Select.name]: Select,
    [Option.name]: Option,
    Treeselect,
    Header,
  },
  data() {
    return {
      id: this.$route.params.id,
      existingApprovedById: null,
      buttonDisabled: false,
      visible: false,
      countrySelected: [],
      isVisible: false,
      endDatePickerOptions: {
        disabledDate: this.disabledEndDate,
      },

    };
  },
  watch: {
    user: {
      deep: true,
      handler(newUserData, oldUserData) {
        if (newUserData.approvalStatusId !== 1) {
          this.existingApprovedById = oldUserData.approverId;
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      jointStaffOrganizations: "organization/jointStaffOrganizations",
      roles: "role/roles",
      approvalStatuses: "approvalStatus/approvalStatuses",
      sponsorUsers: "users/sponsorUsers",
      user: "users/user",
      authenticatedUser: "users/authenticatedUser",
      isOUSD: "authentication/isOUSD",
      isSuperAdmin: "authentication/isSuperAdmin",
      allCountries: "countries/allCountries",
      isPNManager: "authentication/isPNManager",

    }),
    isPartner() {
      return this.user && this.user.roleString == Util.PARTNER_NATION;
    },
    isApprovedUser() {
      return this.user.approvalStatusId == 2 ? true : false;
    },
    isPartnerRoleAssigned() {
      return this.user.roles.includes(Util.PARTNER_NATION);
    },
    filteredRoles() {
      if (this.user.approvalStatusId != 1) {
        return this.roles.filter((role) => {
          return role.name !== "Pending";
        });
      } else {
        return this.roles;
      }
    },
    lastLoggedInInfo() {
      return Util.isNullOrEmpty(this.user.lastLoginDate)
        ? `We do not have record of the last time ${this.user.firstName} logged in.`
        : `${this.user.firstName
        } last logged in on: ${Util.formatDateWithLocalTimezone(
          this.user.lastLoginDate
        )}`;
    },
    confirmedEmailInfo() {
      return this.user.emailConfirmed
        ? `${this.user.firstName}'s email IS confirmed.`
        : `${this.user.firstName}'s email is NOT confirmed.`;
    },
    createdDate() {
      return Util.isNullOrEmpty(this.user.createDate) ?
        `We do not have record of Create date for the user` :
        `${this.user.firstName} registered on: ${Util.formatDateWithLocalTimezone(this.user.createDate)}`
    },
    lastUpdatedByInfo() {
      const str = this.user.updatedBy;
      if (str) {      // Extract the name part
        const namePart = str.substring(0, str.indexOf('--'));
        // Extract the email part
        const emailPart = str.substring(str.indexOf('--') + 3, str.lastIndexOf('--') - 1);
        // Extract the date and time part
        const dateTimePart = str.substring(str.lastIndexOf('--') + 3);
        const formattedDate = Util.formatDateWithLocalTimezone(dateTimePart)


        return Util.isNullOrEmpty(this.user.updatedById) ?
          `We do not have record of last updated by for the user` :
          `Profile last updated by  ${namePart}--${emailPart}--${formattedDate}`
      }
    },
    selectedSponserUserLabel() {
      let selectedUser;
      if (this.user.approverId) {
        selectedUser = this.sponsorUsers.find(
          (user) => user.id === this.user.approverId
        );
      }
      return selectedUser ? selectedUser.nameLabel : "No user selected";
    },
    userCountries() {
      var str = '';
      if (this.user.countriesToManage) {
        if (this.user.countriesToManage.length > 0)
          str = this.user.countriesToManage[0].name;
        return str;
      }

    },
    isAllowEdit() {
      return !this.isSuperAdmin
    },
  },
  async mounted() {
    this.$loaderApp.addRequest();
    await this.getJointStaffOrganizations();
    await this.getRoles(this.$route.params.id);
    await this.getApprovalStatuses();
    await this.getSponsorUsers();
    await this.getUserByEmail();
    await this.getAllCountries();
    await this.getUser(this.$route.params.id);
    await this.validateOrganization(this.user.organizationId);
    this.$loaderApp.completeRequest();
    await this.getSelectedCountries();
    await this.checkRoles('PartnerNationManager')

  },
  methods: {
    ...mapActions({
      getJointStaffOrganizations: "organization/getJointStaffOrganizations",
      getRoles: "role/getUserRoles",
      getApprovalStatuses: "approvalStatus/getApprovalStatuses",
      getSponsorUsers: "users/getSponsorUsers",
      updateUser: "users/updateUserAdmin",
      getUser: "users/getUser",
      getUserByEmail: "authentication/getUserByEmail",
      getAllCountries: "countries/getAllCountries",

    }),
    disabledEndDate(time) {
      let disabled = false;
      let userRoles = this.user.roles;
      if (!Util.isNullOrEmpty(this.user.expirationDate)) {
        const selectedTime = new moment(time.getTime());
        let maxEndDate = null;
        // today's date
        const minstartDate = new moment(moment());
        if (userRoles) {
          maxEndDate = new moment(minstartDate).add(
            1,
            "year"
          );
        }

        // not less then today
        if (selectedTime < minstartDate) {
          disabled = true;
        }
        // not greater than a year from today
        if (selectedTime > maxEndDate) {
          disabled = true;
        }
      }
      return disabled;
    },

    selectable(option) {
      // if this use is an admin, all options are selectable
      // except admin-self and the current editing user-self
      if (this.isSuperAdmin) {
        return option.id !== this.getMyself.id && option.id !== this.user.id;
      }
      // can only select/assign yourself to the user that you want to modify
      return option.id === this.getMyself.id;
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validateOrganization(organizationId) {
      let ctx = this;
      let found = ctx.jointStaffOrganizations.find(
        (o) => o.organizationId === organizationId || 48
      );

      return (found && found.organizationId) || 48;
    },
    async checkRoles(role) {
      let userRoles = await this.user.roles
      if (userRoles) {
        if (userRoles.includes(role)) {
          this.isVisible = true
          return false
        } else {
          this.isVisible = false
          return true
        }
      }
    },
    async updateProfile(id) {
      const ctx = this;
      let countries = this.countrySelected.map(x => {
        let item = this.allCountries.find(item => item.name === x);
        if (item) {
          return item.id
        }
      })

      this.user.countryIds = countries
      ctx
        .updateUser({ isSuperAdmin: true })
        .then(
          async (res) => {
            if (res.status != false) {
              await ctx.getUser(this.id);
          new swal({
            title: "Successfully Saved",
            text: `User information updated successfully!`,
            icon: "success",
            confirmButtonColor: "#10b45a",
          });
          if(this.user.roles.includes("PartnerNationManager")){
            await this.getSelectedCountries();
            this.isVisible = true
          }else{
            this.isVisible = false
          }  
          }else{
            ctx.getUser(this.id);
              new swal({
                title: "Error!",
                text: `${res.res}`,
                icon: "error",
                confirmButtonColor: "#10b45a",
              });
            }
          })
        .catch((error) => {
          new swal({
            title: "Error!",
            text: `${error.response.data}`,
            icon: "error",
            confirmButtonColor: "#10b45a",
          });
        });

    },
    resendEmailConfirmation() {
      this.buttonDisabled = true;
      const id = this.$route.params.id;
      const params = {
        id,
      };
      axios
        .get("api/authentication/resendconfirmemail", {
          params,
        })
        .then((response) => {
          new swal({
            title: "Success!",
            text: "Email Resent successfully",
            icon: "success",
            confirmButtonColor: "#10b45a",
          });
          this.buttonDisabled = false;
        })
        .catch((err) => {
          new swal({
            title: "Error!",
            text: "Email Resend Failed!",
            icon: "error",
            confirmButtonColor: "#10b45a",
          });
          this.buttonDisabled = false;
        });
    },
    getSelectedCountries() {
      var countries = this.user.countriesToManage
      let result = countries.map(a => a.name);
      this.countrySelected = result
    }
  }
};
</script>

<style scoped>
.edit_information_grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
}

@media only screen and (max-width: 1200px) {
  .edit_information_grid {
    grid-template-columns: 1fr;
  }
}


.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.box-card {
  width: 280px;
  height: 150px;
  overflow: auto;
}
</style>